
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Toasted from 'vue-toasted';
import { initClient } from '../../api';
import { formatDateTime } from '../../util';
import Visible from '../../directives/visible';
import AskModal from '../aiAsk/AskModal';

Vue.use(Toasted, { duration: 2000 });

@Component({
  name: 'AiSearchComponent',
  components: {
    AskModal: require('../aiAsk/AskModal.vue').default
  },
  directives: {
    Visible,
  },
})
export default class AiSearchComponent extends Vue {
  modalOpen: boolean = false;    
  async mounted(): Promise<void> {
  }


  openModal(kind: string): void {
    if (kind === 'upload') {
    } else {
     this.modalOpen=true;
      (this.$refs.askModal as AskModal).open();
    }
  }


}
